import React, { useState, useEffect } from 'react';
import InfoCard from './InfoCard';


const API_URL = process.env.REACT_APP_API_URL || '/api';
function MyBookings({ userId, equipmentModels, requestsType }) {
  const [bookings, setBookings] = useState([]);
  const [offers, setOffers] = useState([]);
  const [receivedOffers, setReceivedOffers] = useState([]);
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState('customer_pending');

  useEffect(() => {
    fetchAllData();
  }, []);

  const fetchAllData = async () => {
    setLoading(true);
    const token = localStorage.getItem('token');
    
    if (!token) {
      console.error('❌ Нет токена авторизации');
      setLoading(false);
      return;
    }
    
    const authHeaders = {
      'Authorization': `Bearer ${token}`
    };
    
    try {
      // ✅ Бронирования (с токеном)
      const bookingsRes = await fetch(`${API_URL}/my-bookings/${userId}`, {
        headers: authHeaders
      });
      
      if (bookingsRes.ok) {
        const bookingsData = await bookingsRes.json();
        // ✅ Проверяем, что это массив
        setBookings(Array.isArray(bookingsData) ? bookingsData : []);
      } else {
        console.error('Ошибка загрузки бронирований:', bookingsRes.status);
        setBookings([]);
      }
      
      // ✅ Заявки (публичный эндпоинт)
      const requestsRes = await fetch('/api/requests');
      if (requestsRes.ok) {
        const allRequests = await requestsRes.json();
        setRequests(Array.isArray(allRequests) ? allRequests : []);
      } else {
        setRequests([]);
      }
      
      // ✅ Предложения исполнителя (с токеном)
      const offersRes = await fetch(`${API_URL}/offers/executor/${userId}`, {
        headers: authHeaders
      });
      if (offersRes.ok) {
        const offersData = await offersRes.json();
        setOffers(Array.isArray(offersData) ? offersData : []);
      } else {
        setOffers([]);
      }
      
      // ✅ Полученные предложения (с токеном)
      const receivedRes = await fetch(`${API_URL}/offers/customer/${userId}`, {
        headers: authHeaders
      });
      if (receivedRes.ok) {
        const receivedData = await receivedRes.json();
        setReceivedOffers(Array.isArray(receivedData) ? receivedData : []);
      } else {
        setReceivedOffers([]);
      }
    } catch (error) {
      console.error('Ошибка загрузки данных:', error);
      setBookings([]);
      setOffers([]);
      setReceivedOffers([]);
      setRequests([]);
    } finally {
      setLoading(false);
    }
  };

  // Функции действий (оставьте без изменений)
  const acceptBooking = async (bookingId) => {
    if (!window.confirm('Подтвердить бронирование?')) return;
    try {
      const response = await fetch(`${API_URL}/bookings/${bookingId}/accept`, {
        method: 'PUT',
        headers: { 
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        body: JSON.stringify({ owner_id: userId })
      });
      if (response.ok) {
        alert('Бронирование подтверждено!');
        fetchAllData();
      } else {
        const err = await response.json();
        alert(err.error || 'Ошибка');
      }
    } catch (error) {
      console.error(error);
    }
  };

  const rejectBooking = async (bookingId) => {
    if (!window.confirm('Отклонить бронирование?')) return;
    try {
      const response = await fetch(`${API_URL}/bookings/${bookingId}/reject`, {
        method: 'PUT',
        headers: { 
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        body: JSON.stringify({ owner_id: userId })
      });
      if (response.ok) {
        alert('Бронирование отклонено');
        fetchAllData();
      } else {
        const err = await response.json();
        alert(err.error || 'Ошибка');
      }
    } catch (error) {
      console.error(error);
    }
  };

  const cancelByCustomer = async (bookingId) => {
    if (!window.confirm('Отменить бронирование?')) return;
    try {
      const response = await fetch(`${API_URL}/bookings/${bookingId}/cancel-by-customer`, {
            method: 'PUT',
            headers: { 
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            },
            body: JSON.stringify({ customer_id: userId })
        });
      if (response.ok) {
        alert('Бронирование отменено');
        fetchAllData();
      } else {
        const err = await response.json();
        alert(err.error || 'Ошибка');
      }
    } catch (error) {
      console.error(error);
    }
  };

  // ✅ Повторная оплата брони
  const retryPayment = async (bookingId) => {
    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`${API_URL}/bookings/${bookingId}/pay`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });
      
      const data = await response.json();
      
      if (response.ok && data.paymentUrl) {
        // Перенаправляем на оплату
        window.location.href = data.paymentUrl;
      } else {
        alert(data.error || 'Ошибка повторной оплаты');
      }
    } catch (error) {
      console.error('Ошибка:', error);
      alert('Ошибка повторной оплаты');
    }
  };

 const completeBooking = async (bookingId, paymentId) => {
    console.log(`🔍 completeBooking: bookingId=${bookingId}, paymentId=${paymentId}`);
    
    if (!paymentId) {
        alert('Ошибка: идентификатор платежа не найден');
        return;
    }
    
    if (!window.confirm('Подтвердить выполнение работ? После этого деньги будут списаны с карты заказчика.')) return;
    
    try {
        const response = await fetch(`${API_URL}/capture-payment`, {
            method: 'POST',
            headers: { 
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            },
            body: JSON.stringify({ 
                paymentId: paymentId,
                bookingId: bookingId 
            })
        });
        
        const data = await response.json();
        
        if (response.ok) {
            alert('Оплата подтверждена! Деньги переведены исполнителю.');
            fetchAllData(); // обновить список
        } else {
            alert(data.error || 'Ошибка подтверждения платежа');
        }
    } catch (error) {
        console.error('Ошибка:', error);
        alert('Ошибка при подтверждении оплаты');
    }
};


  // ✅ Исполнитель: отметить работу выполненной
  const markDone = async (bookingId) => {
    if (!window.confirm('Отметить работу как выполненную? Заказчик получит уведомление для подтверждения.')) return;
    try {
      const response = await fetch(`${API_URL}/bookings/${bookingId}/mark-done`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + localStorage.getItem('token')
        }
      });
      if (response.ok) {
        alert('Отмечено! Ждём подтверждения заказчика.');
        fetchAllData();
      } else {
        const err = await response.json();
        alert(err.error || 'Ошибка');
      }
    } catch (e) { console.error(e); }
  };

  // ✅ Заказчик: открыть спор
  const openDispute = async (bookingId) => {
    const reason = window.prompt('Опишите проблему (не выполнено / некачественно / другое):');
    if (reason === null) return;
    try {
      const response = await fetch(`${API_URL}/bookings/${bookingId}/dispute`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + localStorage.getItem('token')
        },
        body: JSON.stringify({ reason })
      });
      if (response.ok) {
        alert('Спор открыт. Деньги останутся заморожены до решения администратора.');
        fetchAllData();
      } else {
        const err = await response.json();
        alert(err.error || 'Ошибка');
      }
    } catch (e) { console.error(e); }
  };

  const acceptOffer = async (offerId) => {
    if (!window.confirm('Принять предложение?')) return;
    try {
      const response = await fetch(`${API_URL}/offers/${offerId}/accept`, {
        method: 'PUT',
        headers: { 
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
        });
      if (response.ok) {
        alert('Предложение принято! Создано бронирование.');
        fetchAllData();
      } else {
        const err = await response.json();
        alert(err.error || 'Ошибка');
      }
    } catch (error) {
      console.error(error);
    }
  };

  const rejectOffer = async (offerId) => {
    if (!window.confirm('Отклонить предложение?')) return;
    try {
      const response = await fetch(`${API_URL}/offers/${offerId}/reject`, {
        method: 'PUT',
        headers: { 
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
        });
      if (response.ok) {
        alert('Предложение отклонено');
        fetchAllData();
      }
    } catch (error) {
      console.error(error);
    }
  };

  const cancelOffer = async (offerId) => {
    if (!window.confirm('Отменить предложение?')) return;
    try {
     const response = await fetch(`${API_URL}/offers/${offerId}/cancel`, {
            method: 'PUT',
            headers: { 
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
        });
      if (response.ok) {
        alert('Предложение отменено');
        fetchAllData();
      }
    } catch (error) {
      console.error(error);
    }
  };

  // Фильтры
  // ✅ Контакты видны только для оплаченных броней
const withVisibility = (b) => ({
  ...b,
  phone_visible: b.payment_status === 'paid',
  display_phone: b.payment_status === 'paid'
    ? (b.request?.phone_number || b.customer_phone)
    : '+7 *** *** ** **'
});

const customerPendingBookings = bookings.filter(b => b.customer_id === userId && b.status === 'pending').map(withVisibility);
  // Заказчик: активные — это confirmed ИЛИ work_done (он должен видеть карточки, где решает он)
  const customerConfirmedBookings = bookings.filter(b => b.customer_id === userId && ['confirmed', 'work_done'].includes(b.status)).map(withVisibility);
  const customerCompletedBookings = bookings.filter(b => b.customer_id === userId && b.status === 'completed').map(withVisibility);
  const customerDisputedBookings = bookings.filter(b => b.customer_id === userId && b.status === 'disputed').map(withVisibility);
  // Исполнитель: активные — confirmed ИЛИ work_done (он видит статус, даже если уже отметил)
  const ownerPendingBookings = bookings.filter(b => b.owner_id === userId && b.status === 'pending');
  const ownerConfirmedBookings = bookings.filter(b => b.owner_id === userId && ['confirmed', 'work_done'].includes(b.status));
  const ownerCompletedBookings = bookings.filter(b => b.owner_id === userId && b.status === 'completed');
  const ownerDisputedBookings = bookings.filter(b => b.owner_id === userId && b.status === 'disputed');
  const customerOffers = receivedOffers.filter(o => o.status === 'pending');
  const executorPendingOffers = offers.filter(o => o.status === 'pending');

  if (loading) return <div>Загрузка...</div>;

  return (
    <div>
      <h2>Работа с заявками</h2>
      
      <div style={{ display: 'flex', gap: '10px', marginBottom: '20px', flexWrap: 'wrap' }}>
        <button onClick={() => setActiveTab('customer_pending')} style={{ padding: '10px', backgroundColor: activeTab === 'customer_pending' ? '#ff9800' : '#f0f0f0', border: 'none', borderRadius: '5px', cursor: 'pointer' }}>⏳ Ожидают подтверждения ({customerPendingBookings.length})</button>
        <button onClick={() => setActiveTab('customer_active')} style={{ padding: '10px', backgroundColor: activeTab === 'customer_active' ? '#2196F3' : '#f0f0f0', border: 'none', borderRadius: '5px', cursor: 'pointer' }}>✅ Мои активные заказы ({customerConfirmedBookings.length})</button>
        <button onClick={() => setActiveTab('customer_completed')} style={{ padding: '10px', backgroundColor: activeTab === 'customer_completed' ? '#4CAF50' : '#f0f0f0', border: 'none', borderRadius: '5px', cursor: 'pointer' }}>📦 Мои завершённые ({customerCompletedBookings.length})</button>
        <button onClick={() => setActiveTab('customer_disputed')} style={{ padding: '10px', backgroundColor: activeTab === 'customer_disputed' ? '#f44336' : '#f0f0f0', color: activeTab === 'customer_disputed' ? '#fff' : '#000', border: 'none', borderRadius: '5px', cursor: 'pointer' }}>⚠️ Мои споры ({customerDisputedBookings.length})</button>
        <button onClick={() => setActiveTab('customer_offers')} style={{ padding: '10px', backgroundColor: activeTab === 'customer_offers' ? '#4CAF50' : '#f0f0f0', border: 'none', borderRadius: '5px', cursor: 'pointer' }}>💰 Предложения мне ({customerOffers.length})</button>
        <button onClick={() => setActiveTab('executor_pending')} style={{ padding: '10px', backgroundColor: activeTab === 'executor_pending' ? '#ff9800' : '#f0f0f0', border: 'none', borderRadius: '5px', cursor: 'pointer' }}>📋 Новые заявки ({ownerPendingBookings.length})</button>
        <button onClick={() => setActiveTab('executor_active')} style={{ padding: '10px', backgroundColor: activeTab === 'executor_active' ? '#4CAF50' : '#f0f0f0', border: 'none', borderRadius: '5px', cursor: 'pointer' }}>🚜 Активные заказы ({ownerConfirmedBookings.length})</button>
        <button onClick={() => setActiveTab('executor_completed')} style={{ padding: '10px', backgroundColor: activeTab === 'executor_completed' ? '#4CAF50' : '#f0f0f0', border: 'none', borderRadius: '5px', cursor: 'pointer' }}>✅ Завершённые (я сдал) ({ownerCompletedBookings.length})</button>
        <button onClick={() => setActiveTab('executor_disputed')} style={{ padding: '10px', backgroundColor: activeTab === 'executor_disputed' ? '#f44336' : '#f0f0f0', color: activeTab === 'executor_disputed' ? '#fff' : '#000', border: 'none', borderRadius: '5px', cursor: 'pointer' }}>⚠️ Споры ({ownerDisputedBookings.length})</button>
        <button onClick={() => setActiveTab('executor_offers')} style={{ padding: '10px', backgroundColor: activeTab === 'executor_offers' ? '#ff9800' : '#f0f0f0', border: 'none', borderRadius: '5px', cursor: 'pointer' }}>📤 Мои предложения ({executorPendingOffers.length})</button>
      </div>

      {/* Вкладка: Ожидают подтверждения (заказчик) */}
      {activeTab === 'customer_pending' && (
        <>
          <h3>⏳ Ожидают подтверждения</h3>
          {customerPendingBookings.length === 0 && <p>Нет заявок, ожидающих подтверждения</p>}
          {customerPendingBookings.map(booking => (
            <InfoCard
              key={booking.id}
              type="booking"
              data={booking}
              equipmentModels={equipmentModels}
              requestsType={requestsType}
              actions={
                <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                  {booking.payment_status === 'unpaid' && (
                    <button 
                      onClick={() => retryPayment(booking.id)} 
                      style={{ backgroundColor: '#2196F3', color: 'white', padding: '8px 16px', border: 'none', borderRadius: '4px', cursor: 'pointer' }}
                    >
                      💳 Оплатить
                    </button>
                  )}
                  <button onClick={() => cancelByCustomer(booking.id)} style={{ backgroundColor: '#f44336', color: 'white', padding: '8px 16px', border: 'none', borderRadius: '4px', cursor: 'pointer' }}>❌ Отменить</button></div>
              }
            />
          ))}
        </>
      )}

      {/* Вкладка: Мои заказы (заказчик) */}
      {activeTab === 'customer_active' && (
        <>
          <h3>✅ Мои активные заказы</h3>
          {customerConfirmedBookings.length === 0 && <p>Нет активных заказов</p>}
          {customerConfirmedBookings.map(booking => (
            <InfoCard
              key={booking.id}
              type="booking"
              data={booking}
              equipmentModels={equipmentModels}
              requestsType={requestsType}
              actions={
                booking.status === 'work_done' ? (
                  <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                    <button onClick={() => completeBooking(booking.id, booking.payment_id)} style={{ backgroundColor: '#2196F3', color: 'white', padding: '8px 16px', border: 'none', borderRadius: '4px', cursor: 'pointer' }}>✅ Работа выполнена</button>
                    <button onClick={() => openDispute(booking.id)} style={{ backgroundColor: '#f44336', color: 'white', padding: '8px 16px', border: 'none', borderRadius: '4px', cursor: 'pointer' }}>⚠️ Работа не выполнена</button>
                  </div>
                ) : booking.status === 'confirmed' ? (
                  <div style={{ fontSize: '13px', color: '#666', fontStyle: 'italic', padding: '8px 0' }}>
                    ⏳ Ждём, когда исполнитель отметит работу
                  </div>
                ) : null
              }
            />
          ))}
        </>
      )}

      {activeTab === 'customer_completed' && (
        <>
          <h3>📦 Мои завершённые заказы (как заказчик)</h3>
          {customerCompletedBookings.length === 0 && <p>Нет завершённых заказов</p>}
          {customerCompletedBookings.map(booking => (
            <InfoCard
              key={booking.id}
              type="booking"
              viewMode="customer"
              data={booking}
              equipmentModels={equipmentModels}
              requestsType={requestsType}
            />
          ))}
        </>
      )}

      {/* Вкладка: Предложения мне (заказчик) */}
      {activeTab === 'customer_offers' && (
        <>
          <h3>💰 Предложения от исполнителей</h3>
          {customerOffers.length === 0 && <p>Нет предложений</p>}
          {customerOffers.map(offer => {
            const request = requests.find(r => r.id === offer.request_id);
            const combinedData = { ...request, ...offer, address: request?.address, city: request?.city };
            return (
              <InfoCard
                key={offer.id}
                type="offer"
                viewMode="customer"
                data={combinedData}
                equipmentModels={equipmentModels}
                requestsType={requestsType}
                actions={
                  <div style={{ display: 'flex', gap: '10px' }}>
                    <button onClick={() => acceptOffer(offer.id)} style={{ backgroundColor: '#4CAF50', color: 'white', padding: '8px 16px', border: 'none', borderRadius: '4px', cursor: 'pointer' }}>✅ Принять</button>
                    <button onClick={() => rejectOffer(offer.id)} style={{ backgroundColor: '#f44336', color: 'white', padding: '8px 16px', border: 'none', borderRadius: '4px', cursor: 'pointer' }}>❌ Отклонить</button>
                  </div>
                }
              />
            );
          })}
        </>
      )}

      {/* Вкладка: Новые заявки (исполнитель) */}
      {activeTab === 'executor_pending' && (
        <>
          <h3>📋 Новые заявки на бронирование</h3>
          {ownerPendingBookings.length === 0 && <p>Нет новых заявок</p>}
          {ownerPendingBookings.map(booking => (
            <InfoCard
              key={booking.id}
              type="booking"
              viewMode="executor"
              data={booking}
              equipmentModels={equipmentModels}
              requestsType={requestsType}
              actions={
                <div style={{ display: 'flex', gap: '10px' }}>
                  <button onClick={() => acceptBooking(booking.id)} className="btn btn-success">
  ✅ Подтвердить выполнение работ
</button>
                  <button onClick={() => rejectBooking(booking.id)} style={{ backgroundColor: '#f44336', color: 'white', padding: '8px 16px', border: 'none', borderRadius: '4px', cursor: 'pointer' }}>❌ Отклонить</button>
                </div>
              }
            />
          ))}
        </>
      )}

      {/* Вкладка: Активные заказы (исполнитель) */}
      {activeTab === 'executor_active' && (
        <>
          <h3>🚜 Активные заказы</h3>
          {ownerConfirmedBookings.length === 0 && <p>Нет активных заказов</p>}
          {ownerConfirmedBookings.map(booking => (
            <InfoCard
              key={booking.id}
              type="booking"
              viewMode="executor"
              data={booking}
              equipmentModels={equipmentModels}
              requestsType={requestsType}
              actions={
                booking.status === 'confirmed' ? (
                  <button onClick={() => markDone(booking.id)} style={{ backgroundColor: '#4CAF50', color: 'white', padding: '8px 16px', border: 'none', borderRadius: '4px', cursor: 'pointer' }}>
                    ✅ Я выполнил работу
                  </button>
                ) : booking.status === 'work_done' ? (
                  <div style={{ fontSize: '13px', color: '#666', fontStyle: 'italic', padding: '8px 0' }}>
                    ⏳ Ждём, когда заказчик подтвердит
                  </div>
                ) : null
              }
            />
          ))}
        </>
      )}

      {/* Вкладка: Завершённые (исполнитель) */}
      {activeTab === 'executor_completed' && (
        <>
          <h3>✅ Завершённые заказы (я сдал технику)</h3>
          {ownerCompletedBookings.length === 0 && <p>Нет завершённых заказов</p>}
          {ownerCompletedBookings.map(booking => (
            <InfoCard
              key={booking.id}
              type="booking"
              viewMode="executor"
              data={booking}
              equipmentModels={equipmentModels}
              requestsType={requestsType}
            />
          ))}
        </>
      )}


      {/* Вкладка: Мои споры (заказчик) */}
      {activeTab === 'customer_disputed' && (
        <>
          <h3>⚠️ Мои споры</h3>
          {customerDisputedBookings.length === 0 && <p>Нет активных споров</p>}
          {customerDisputedBookings.map(booking => (
            <InfoCard
              key={booking.id}
              type="booking"
              viewMode="customer"
              data={booking}
              equipmentModels={equipmentModels}
              requestsType={requestsType}
              actions={
                <div style={{ fontSize: '13px', color: '#92400e', fontStyle: 'italic', padding: '8px 0' }}>
                  ⏳ Спор открыт. Администратор свяжется с вами в течение 1-2 дней.
                </div>
              }
            />
          ))}
        </>
      )}

      {/* Вкладка: Споры (исполнитель) */}
      {activeTab === 'executor_disputed' && (
        <>
          <h3>⚠️ Споры</h3>
          {ownerDisputedBookings.length === 0 && <p>Нет активных споров</p>}
          {ownerDisputedBookings.map(booking => (
            <InfoCard
              key={booking.id}
              type="booking"
              viewMode="executor"
              data={booking}
              equipmentModels={equipmentModels}
              requestsType={requestsType}
              actions={
                <div style={{ fontSize: '13px', color: '#92400e', fontStyle: 'italic', padding: '8px 0' }}>
                  ⏳ Заказчик открыл спор. Администратор свяжется с вами.
                </div>
              }
            />
          ))}
        </>
      )}

      {/* Вкладка: Мои предложения (исполнитель) */}
      {activeTab === 'executor_offers' && (
        <>
          <h3>📤 Мои предложения</h3>
          {executorPendingOffers.length === 0 && <p>Нет активных предложений</p>}
          {executorPendingOffers.map(offer => {
            const request = requests.find(r => r.id === offer.request_id);
            const combinedData = { ...offer, ...request, payout: offer.payout ?? offer.price, address: request?.address, city: request?.city };
            return (
              <InfoCard
                key={offer.id}
                type="offer"
                viewMode="executor"
                data={combinedData}
                equipmentModels={equipmentModels}
                requestsType={requestsType}
                actions={
                  <button onClick={() => cancelOffer(offer.id)} style={{ backgroundColor: '#f44336', color: 'white', padding: '8px 16px', border: 'none', borderRadius: '4px', cursor: 'pointer' }}>❌ Отменить предложение</button>
                }
              />
            );
          })}
        </>
      )}
    </div>
  );
}

export default MyBookings;